module.exports = __webpack_public_path__ + "static/media/autokar3 (1).08613b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (1).jpg
// module id = 855
// module chunks = 0